<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="sisUsuario" titulo="Usuarios / Sistema" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">

  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0em;">
    <div style="background: #FFF; border-radius: 0em; ">

      <!-- inicio formulario -->
      <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
        <section class="hero is-primary">
          <div class="hero-body">

            <!-- Opciones  -->
            <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
          </div>
        </section>
        <div class="is-fullwidth has-text-centered" *ngIf="!ctrl.datosCargados">
          <br>
          <span class="tag is-primary is-large ">
            <span class="icon">
              <i class="fa fa-refresh fa-spin"></i>
            </span> &nbsp;
            <span>Cargando...</span>
          </span>
        </div>

        <section class="section" style="overflow: auto;padding: 1rem !important;height: 87.3vh;">

          <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
          <a id="catalogos" (click)="ctrl.cargarCatalogo('tipos_medios', 'tipo-medio'); ctrl.cargarCatalogo('catalogo', 'permiso'); ctrl.iniciar_derecha('g'); ctrl.iniciar_derecha('d'); ctrl.iniciar_derecha('r'); ctrl.iniciar_izquierda('g'); ctrl.iniciar_izquierda('d'); ctrl.iniciar_izquierda('r'); ctrl.cargarCatalogo('paises', 'paises'); ctrl.cargarCatalogo('sis_usuarios_grupos', 'sisGrupo', 'initMover'); "></a>
          <a id="recargar" (click)="ctrl.catalogoDependiente('estados', 'estados', ctrl.dato.get('paises_id').value); ctrl.catalogoDependiente('municipios', 'municipios', ctrl.dato.get('estados_id').value); empresas_sucursales();"></a>
          <div class="contenedor columns">
            <div class="column is-one-quarter menu-persona is-hidden-touch">
              <div>
                <figure class="image is-3by2">
                  <img *ngIf="!ctrl.subir[0]" [src]="ctrl.API_PATH+'/adjunto/usuario/'+ctrl.dato.get('foto').value" alt="Foto" />
                  <img *ngIf="ctrl.subir[0]" [src]="'data:image/jpg;base64,'+ctrl.dato.get('foto').value" alt="Foto" />
                </figure>
                <div align="center">
                  <strong>{{ctrl.dato.get('nombre').value}}</strong>
                  <small>{{ctrl.dato.get('email').value}}</small>
                </div>
                <hr>
                <nav class="panel" *ngIf="ctrl.dato.controls.sis_usuarios_contactos.controls.length > 0">
                  <p class="panel-heading">
                    Contactos
                  </p>
                  <div class="panel-block" *ngFor="let medio of ctrl.dato.controls.sis_usuarios_contactos.controls; let suc = index;">
                    <span class="panel-icon" *ngIf="ctrl.tipos_medios?.length > 0">
                      <i [ngClass]="ctrl.tipos_medios[medio.value.tipos_medios_id - 1]?.icon"></i>
                    </span> {{ medio.value.valor }}
                  </div>
                </nav>

              </div>
            </div>
            <div class="column ">

              <div class="tabs is-boxed" style="margin-top: -10px;">

                <!-- se crea los tab se debe definir una variable llamada tab en el .ts con un valor por default ejemplo tab=1 -->
                <ul>
                  <li [ngClass]="{ 'is-active' : tab == 1}">
                    <a (click)="tab=1">
                      <span class="icon">
                        <i class="fa fa-file"></i>
                      </span>
                      <span class="is-hidden-touch">General</span>
                    </a>
                  </li>

                  <li [ngClass]="{ 'is-active' : tab == 2}">
                    <a (click)="tab=2">
                      <span class="icon">
                        <i class="fa fa-lock"></i>
                      </span>
                      <span class="is-hidden-touch">Seguridad</span>
                    </a>
                  </li>

                  <li [ngClass]="{ 'is-active' : tab == 3}">
                    <a (click)="tab=3">
                      <span class="icon">
                        <i class="fa fa-book"></i>
                      </span>
                      <span class="is-hidden-touch">Contacto</span>
                    </a>
                  </li>

                  <li [ngClass]="{ 'is-active' : tab == 4}">
                    <a (click)="tab=4">
                      <span class="icon">
                        <i class="fa fa-credit-card"></i>
                      </span>
                      <span class="is-hidden-touch">RFC</span>
                    </a>
                  </li>

                  <li [ngClass]="{ 'is-active' : tab == 5}">
                    <a (click)="tab=5">
                      <span class="icon">
                        <i class="fa fa-users"></i>
                      </span>
                      <span class="is-hidden-touch">Grupos</span>
                    </a>
                  </li>

                  <li [ngClass]="{ 'is-active' : tab == 6}">
                    <a (click)="tab=6">
                      <span class="icon">
                        <i class="fa fa-building"></i>
                      </span>
                      <span class="is-hidden-touch">Sucursales</span>
                    </a>
                  </li>

                  <li [ngClass]="{ 'is-active' : tab == 7}">
                    <a (click)="tab=7">
                      <span class="icon">
                        <i class="fa fa-lock"></i>
                      </span>
                      <span class="is-hidden-touch">Permisos ind</span>
                    </a>
                  </li>

                </ul>
              </div>
              <!--general -->
              <div [ngClass]="{ 'is-hidden': tab != 1}">
                <div class="columns">
                  <div class="column is-12">
                    <div class="field">
                      <label class="label">Nombre:</label>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required') }"
                          placeholder="nombre" formControlName="nombre">
                        <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                          <i class="fa fa-warning"></i>
                        </span>
                        <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo
                          es
                          requerido.</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-12">
                    <div class="field">
                      <label class="label">Correo eléctronico:</label>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('email').hasError('required') && ctrl.dato.get('email').hasError('required')}"
                          placeholder="Correo eléctronico" formControlName="email">
                        <span class="icon is-small is-right" *ngIf="ctrl.dato.get('email').hasError('required') && ctrl.dato.get('email').hasError('required')">
                          <i class="fa fa-warning"></i>
                        </span>
                        <span class="help is-danger" *ngIf="ctrl.dato.get('email').hasError('required') && ctrl.dato.get('email').hasError('required')">Este
                          campo es requerido.</span>
                      </p>
                    </div>
                  </div>
                </div>

                <div class="columns">
                  <div class="column is-4">
                    <label class="label">País:</label>

                    <ng-select2 [disabled]="ctrl.paises ? ctrl.paises.length == 0 ? true : false : true" name="paises_id" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.paises_id.value"
                      (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.paises_id, 'estados', 'estados');"
                      [data]="ctrl.paises"></ng-select2>

                  </div>

                  <div class="column is-4">
                    <label class="label">Estado:</label>
                    <ng-select2 [disabled]="ctrl.estados ? ctrl.estados.length == 0 ? true : false : true" name="estados_id" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.estados_id.value"
                      (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.estados_id, 'municipios', 'municipios');"
                      [data]="ctrl.estados"></ng-select2>
                  </div>

                  <div class="column is-4">
                    <label class="label">Municipio:</label>
                    <ng-select2 [disabled]="ctrl.municipios ? ctrl.municipios.length == 0 ? true : false : true" name="municipios_id" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.municipios_id.value"
                      (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.municipios_id); " [data]="ctrl.municipios"></ng-select2>
                  </div>
                </div>

                <div class="columns">
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">Direccion:</label>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="text" placeholder="direccion" formControlName="direccion">
                      </p>
                    </div>
                  </div>

                  <div class="column is-3">
                    <div class="field">
                      <label class="label">Num. Exterior:</label>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="text" placeholder="Num. Exterior" formControlName="numero_exterior">
                      </p>
                    </div>
                  </div>

                  <div class="column is-3">
                    <div class="field">
                      <label class="label">Num. Interior:</label>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="text" placeholder="Num. Interior" formControlName="numero_interior">
                      </p>
                    </div>
                  </div>
                </div>

                <div class="columns">
                  <div class="column is-6">
                    <div class="field">
                      <label class="label">Col. / Fracc.:</label>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="text" placeholder="Col. / Fracc." formControlName="colonia">
                      </p>
                    </div>
                  </div>

                  <div class="column is-3">
                    <div class="field">
                      <label class="label">Codigo Postal:</label>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="text" placeholder="CP" formControlName="codigo_postal">
                      </p>
                    </div>
                  </div>

                  <div class="column is-3">
                    <br><br>
                    <div class="field">
                      <div class="b-checkbox is-info">
                        <input id="spam" class="styled" type="checkbox" formControlName="spam">
                        <label for="spam">
                          Acepta recibir información por correo?
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="columns">

                  <div class="column is-4">
                    <div class="field">
                      <label class="label">Ultimo acceso:</label>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('last_login').hasError('required') && ctrl.dato.get('last_login').hasError('required')}"
                          placeholder="Ultimo acceso" formControlName="last_login">
                      </p>
                    </div>
                  </div>

                  <div class="column is-4">
                    <br><br>
                    <div class="field">
                      <div class="b-checkbox is-info">
                        <input id="activo" class="styled" type="checkbox" formControlName="activo">
                        <label for="activo">
                          Esta activo?
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-12">
                    <div class="field">
                      <label class="label">Avatar:</label>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="text" placeholder="Foto" formControlName="avatar">
                      </p>
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-12">
                    <div class="field">
                      <label class="label">foto:</label>
                      <p class="control has-icons-left has-icons-right" *ngIf="ctrl.dato.get('foto').value == ''">
                        <input type="file" (change)="ctrl.seleccionarImagenBase64($event, ctrl.dato.controls.foto)" accept="image/x-png,image/gif,image/jpeg,image/jpg">
                        <input foto type="hidden" formControlName="foto">
                      </p>

                      <button type="button" class="button is-danger" (click)="ctrl.borrarImagen($event, ctrl.dato.controls.foto, 'personas')"
                        *ngIf="ctrl.dato.get('foto').value != ''">

                        <span class="icon">
                          <i class="icon-trash"></i>
                        </span>
                        &nbsp; Eliminar la foto

                      </button>

                    </div>
                  </div>
                </div>

              </div>

              <!--seguridad -->
              <div [ngClass]="{ 'is-hidden': tab != 2}">

                <br>
                <div class="field">
                  <div class="b-checkbox is-info">
                    <input id="cambiarPassword" class="styled" type="checkbox" formControlName="cambiarPassword" (click)="toggleCambiarPassword()">
                    <label for="cambiarPassword">
                      Cambiar contraseña
                    </label>
                  </div>
                </div>
                <hr>

                <div class="field">
                  <label class="label">Usuario:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="text" placeholder="Usuario" formControlName="username">
                  </p>
                </div>

                <div class="field">
                  <label class="label">Contraseña:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="password" placeholder="Contraseña" formControlName="password">
                  </p>
                </div>

                <div class="field">
                  <label class="label">Repetir Contraseña:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="password" placeholder="Repetir Contraseña" formControlName="confirmarPassword">
                  </p>
                </div>
              </div>

              <!--contacto -->
              <div [ngClass]="{ 'is-hidden': tab != 3}">

                <table class="table is-striped  is-fullwidth" *ngIf="ctrl.dato.get('sis_usuarios_contactos').length > 0">
                  <thead>
                    <tr>
                      <th hide-sm>ID</th>
                      <th>Medio de contacto</th>
                      <th>Valor</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody formArrayName="sis_usuarios_contactos">
                    <tr *ngFor="let medio of ctrl.dato.controls.sis_usuarios_contactos.controls; let suc=index"
                      [formGroupName]="suc">
                      <td>{{ suc + 1 }}</td>
                      <td>
                        <ng-select2 [disabled]="ctrl.tipos_medios ? ctrl.tipos_medios.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="medio.controls.tipos_medios_id.value"
                          (valueChanged)="ctrl.seleccionarValorSelect2($event, medio.controls.tipos_medios_id);" [data]="ctrl.tipos_medios"></ng-select2>
                      </td>
                      <td>
                        <p class="control has-icon">
                          <input class="input" formControlName="valor" placeholder="Valor" [ngClass]="{'is-danger': !ctrl.dato.controls.sis_usuarios_contactos.controls[suc].controls.valor.valid}"
                            type="text">
                          <span class="icon">
                            <i [ngClass]="ctrl.tipos_medios[ctrl.dato.controls.sis_usuarios_contactos.controls[suc]?.controls.tipos_medios_id.value - 1]?.icon"></i>
                          </span>
                        </p>

                      </td>
                      <td align="right">
                        <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.sis_usuarios_contactos, suc)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: -20px;">
                  <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.sis_usuarios_contactos, form_sis_usuarios_contactos)">
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
              </div>

              <!--rfc -->
              <div [ngClass]="{ 'is-hidden': tab != 4}">

                <span formArrayName="sis_usuarios_rfcs" *ngIf="ctrl.dato.get('sis_usuarios_rfcs').length > 0">
                  <nav class="panel" *ngFor="let medio of ctrl.dato.controls.sis_usuarios_rfcs.controls; let i=index"
                    [formGroupName]="i">
                    <p class="panel-heading">
                      RFC # {{ i + 1 }}

                      <button style="margin-top: -5px; float:right" type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.sis_usuarios_rfcs, i)">
                        <i class="fa fa-trash"></i>
                      </button>
                    </p>
                    <div class="panel-block">
                      <div style="width:100%">
                        <div class="columns">
                          <div class="column is-6">
                            <div class="field">
                              <label class="label">Razón Social:</label>
                              <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" placeholder="Razón Social" formControlName="razon_social">

                                <span class="help is-danger" *ngIf="!ctrl.dato.controls.sis_usuarios_rfcs.controls[i].controls.razon_social.valid">Este
                                  campo es requerido.</span>
                              </p>
                            </div>
                          </div>
                          <div class="column is-6">
                            <div class="field">
                              <label class="label">Rfc:</label>
                              <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" placeholder="Rfc" formControlName="rfc">

                                <span class="help is-danger" *ngIf="!ctrl.dato.controls.sis_usuarios_rfcs.controls[i].controls.rfc.valid">Este
                                  campo es requerido.</span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column is-6">
                            <div class="field">
                              <div class="field">
                                <label class="label">Correo eléctronico:</label>
                                <p class="control has-icons-left has-icons-right">
                                  <input class="input" type="text" placeholder="Correo eléctronico" formControlName="email">

                                </p>
                              </div>
                            </div>
                          </div>

                          <div class="column is-6">
                            <br>
                            <br>
                            <div class="field">
                              <div class="b-checkbox is-info is-circular">
                                <input id="tipo_persona_f" name="tipo_persona" value="Fisica" class="styled" type="radio"
                                  formControlName="tipo_persona">
                                <label for="tipo_persona_f">
                                  Fisica
                                </label>

                                <input id="tipo_persona_m" name="tipo_persona" value="Moral" class="styled" type="radio"
                                  formControlName="tipo_persona">
                                <label for="tipo_persona_m">
                                  Moral
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column is-4">
                            <label class="label">País:</label>
                            <ng-select2 [disabled]="ctrl.paises ? ctrl.paises.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="medio.controls.paises_id.value"
                              (valueChanged)="ctrl.seleccionarValorSelect2($event, medio.controls.paises_id, 'estados', 'estados'); "
                              [data]="ctrl.paises"></ng-select2>

                          </div>

                          <div class="column is-4">
                            <label class="label">Estado:</label>
                            <ng-select2 [disabled]="ctrl.estados ? ctrl.estados.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="medio.controls.estados_id.value"
                              (valueChanged)="ctrl.seleccionarValorSelect2($event, medio.controls.estados_id, 'municipios', 'municipios'); "
                              [data]="ctrl.estados"></ng-select2>
                          </div>

                          <div class="column is-4">
                            <label class="label">Municipio:</label>
                            <ng-select2 [disabled]="ctrl.municipios ? ctrl.municipios.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="medio.controls.municipios_id.value"
                              (valueChanged)="ctrl.seleccionarValorSelect2($event, medio.controls.municipios_id); "
                              [data]="ctrl.municipios"></ng-select2>
                          </div>
                        </div>

                        <div class="columns">
                          <div class="column is-6">
                            <div class="field">
                              <label class="label">Direccion:</label>
                              <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" placeholder="calle" formControlName="calle">
                              </p>
                            </div>
                          </div>

                          <div class="column is-3">
                            <div class="field">
                              <label class="label">Num. Exterior:</label>
                              <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" placeholder="Num. Exterior" formControlName="numero_exterior">
                              </p>
                            </div>
                          </div>

                          <div class="column is-3">
                            <div class="field">
                              <label class="label">Num. Interior:</label>
                              <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" placeholder="Num. Interior" formControlName="numero_interior">
                              </p>
                            </div>
                          </div>
                        </div>

                        <div class="columns">
                          <div class="column is-4">
                            <div class="field">
                              <label class="label">Localidad:</label>
                              <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" placeholder="Localidad" formControlName="localidad">
                              </p>
                            </div>
                          </div>
                          <div class="column is-4">
                            <div class="field">
                              <label class="label">Col. / Fracc.:</label>
                              <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" placeholder="Col. / Fracc." formControlName="colonia">
                              </p>
                            </div>
                          </div>

                          <div class="column is-4">
                            <div class="field">
                              <label class="label">Codigo Postal:</label>
                              <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" placeholder="CP" formControlName="codigo_postal">
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </nav>
                </span>

                <div style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: 20px;">
                  <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.sis_usuarios_rfcs, form_sis_usuarios_rfcs)">
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
              </div>

              <!--grupos -->
              <div [ngClass]="{ 'is-hidden': tab != 5}">
                <div class="box" *ngIf="ctrl.izquierda['g']">
                  <article class="media">
                    <div class="media-content">
                      <div class="content">
                        <div class="column is-5" style="float:left">
                          <nav class="panel">
                            <div class="panel-heading">
                              <div class="field">
                                <div class="b-checkbox is-info">
                                  <input id="sis_usuarios_grupos" class="styled" type="checkbox" [checked]="ctrl.todosSeleccionados.izquierda"
                                    (click)="ctrl.seleccionarTodosMover('izquierda', ctrl.izquierda['g'], ctrl.sis_usuarios_grupos)">
                                  <label for="sis_usuarios_grupos">
                                    Grupos disponibles
                                  </label>
                                </div>
                              </div>
                            </div>
                            <label class="panel-block" *ngFor="let val of ctrl.sis_usuarios_grupos; let i=index">
                              <div class="field">
                                <div class="b-checkbox is-info">
                                  <input id="sis_usuarios_grupos{{val.id}}" class="styled" type="checkbox" [checked]="ctrl.izquierda['g'].indexOf(val) > -1"
                                    (click)="ctrl.agregarMover(ctrl.izquierda['g'], ctrl.sis_usuarios_grupos, val)">
                                  <label for="sis_usuarios_grupos{{val.id}}">
                                    {{val.nombre}}
                                  </label>
                                </div>
                              </div>

                            </label>
                          </nav>
                        </div>
                        <div class="column is-2" style="float:left">

                          <p class="control">
                            <button class="button is-default" type="button" style="width:100%" [ngClass]="{'is-success': ctrl.izquierda['g'].length > 0}"
                              [disabled]="ctrl.izquierda['g'].length <= 0" (click)="ctrl.iniciarMover('izquierda', ctrl.izquierda['g'], ctrl.dato.controls.sis_usuarios_grupos, ctrl.sis_usuarios_grupos, true); ctrl.iniciar_izquierda('g');">
                              <i class="fa fa-arrow-right"></i>
                            </button>
                          </p>
                          <p class="control">
                            <button class="button is-default" type="button" style="width:100%" [ngClass]="{'is-success': ctrl.derecha['g'].length > 0}"
                              [disabled]="ctrl.derecha['g'].length <= 0" (click)="ctrl.iniciarMover('derecha', ctrl.derecha['g'], ctrl.sis_usuarios_grupos, ctrl.dato.controls.sis_usuarios_grupos, false); ctrl.iniciar_derecha('g');">
                              <i class="fa fa-back"></i>
                            </button>
                          </p>

                        </div>
                        <div class="column is-5" style="float:left">
                          <nav class="panel" formGroupName="sis_usuarios_grupos">
                            <div class="panel-heading">
                              <div class="field">
                                <div class="b-checkbox is-info">
                                  <input id="Missis_usuarios_grupos" class="styled" type="checkbox" [checked]="ctrl.todosSeleccionados.derecha"
                                    (click)="ctrl.seleccionarTodosMover('derecha', ctrl.derecha['g'], ctrl.dato.controls.sis_usuarios_grupos.controls)">
                                  <label for="Missis_usuarios_grupos">
                                    Mis grupos
                                  </label>
                                </div>
                              </div>
                            </div>
                            <label class="panel-block" *ngFor="let item of ctrl.dato.controls.sis_usuarios_grupos.controls; let i2=index">
                              <div class="field" [formGroupName]="i2">
                                <div class="b-checkbox is-info">
                                  <input id="Missis_usuarios_grupos{{item.value.id}}" class="styled" type="checkbox"
                                    [checked]="ctrl.derecha['g'].indexOf(item) > -1" (click)="ctrl.agregarMover(ctrl.derecha['g'], ctrl.dato.controls.sis_usuarios_grupos.controls, item)">
                                  <label for="Missis_usuarios_grupos{{item.value.id}}">
                                    {{item.value.nombre}}
                                  </label>
                                </div>
                              </div>
                            </label>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>

                <!-- ejecuta el movimiento de los datos que ya existen en el lado derecho, parametro 1 formulario reactivo que se guarda en la BD parametro 2 el catalogo en el evento ngAfterViewInit en el .ts  -->
                <a (click)="ctrl.initMover(ctrl.dato.controls.sis_usuarios_grupos.controls, ctrl.sis_usuarios_grupos); "
                  id="initMover"></a>
              </div>

              <!--empresas -->
              <div [ngClass]="{ 'is-hidden': tab != 6}">

                <nav class="panel" *ngFor="let val of usuario.empresas; let i = index;" style="margin-bottom: 0px">
                  <div class="panel-heading">
                    <div class="field">
                      <div class="b-checkbox is-info">
                        <input id="emp{{val.id}}" class="styled" type="checkbox" [checked]="empresa_sel[val.id]" (click)="empresa_sel[val.id] = !empresa_sel[val.id]; addEmpresa(val, ctrl.dato.controls.sis_usuarios_empresas); limpiar_sucursales(val, ctrl.id * 1)">
                        <label for="emp{{val.id}}">
                          {{val.nombre}}
                        </label>
                      </div>
                    </div>
                  </div>
                  <label class="panel-block" *ngFor="let item of val.sucursales; let i2 = index;" [style.display]="empresa_sel[val.id] ? '': 'none'">
                    <div class="field">
                      <div class="b-checkbox is-info">
                        <input id="suc{{item.id}}" class="styled" [checked]="sucursal_sel[item.id] " (click)="addSucursal(item, ctrl.dato.controls.sis_usuarios_sucursales)"
                          type="checkbox">
                        <label for="suc{{item.id}}">
                          {{item.nombre}}
                        </label>
                      </div>
                    </div>

                  </label>
                </nav>


              </div>

              <!--dashboard -->
              <div [ngClass]="{ 'is-hidden': tab != 7}" style="max-width:98%">
                <div class="field">
                  <div class="b-checkbox is-info">
                    <input id="modificar_permiso" class="styled" [checked]="this.dato.get('permisos').value ? this.dato.get('permisos').value != '' ? true : false : false"
                      (click)="modificar_permisos_individuales()" type="checkbox">
                    <label for="modificar_permiso">
                      Marcar esta casilla si se necesita agregar o quitar permisos especificos a la cuenta de este
                      'USUARIO'
                    </label>
                  </div>
                </div>
                <div class="container" *ngIf="this.dato.get('permisos').value" style="width:100%">

                  <div class="tabs is-boxed">
                    <ul>
                      <li [ngClass]="{ 'is-active' : tab2 == i}" *ngFor="let padre of ctrl.catalogo; let i = index;">
                        <a (click)="tab2=i">
                          <span>{{padre.nombre}}</span>
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div class="columns">
                    <div [ngClass]="{ 'is-hidden': tab2 != i2}" *ngFor="let padre of ctrl.catalogo; let i2 = index;">
                      <span *ngIf="padre.es_super ? activar_super ? true : false : true">
                        <div class="column is-4" *ngFor="let hijos of padre.hijos" style="float:left; min-width:300px">
                          <nav class="panel">
                            <div class="panel-heading">
                              <div class="field">
                                <div class="b-checkbox is-info">
                                  <input id="{{hijos.controlador}}" class="styled" type="checkbox" (click)="todosAccion(hijos.controlador, hijos.accion, ctrl.dato.controls.permisos)">
                                  <label for="{{hijos.controlador}}">
                                    {{hijos.nombre}}
                                  </label>
                                </div>
                              </div>

                            </div>
                            <label class="panel-block" *ngFor="let accion of hijos.accion">
                              <div class="field" *ngIf="accion.es_super ? activar_super ? true : false : true">
                                <div class="b-checkbox is-info">
                                  <input id="{{accion.id}}" class="styled" [checked]="ctrl.dato.controls.permisos?.value[hijos?.controlador+'.'+accion?.recurso] == 1"
                                    (click)="agregar_accion(hijos?.controlador+'.'+accion?.recurso)" type="checkbox">
                                  <label for="{{accion.id}}">
                                    {{accion.nombre}}
                                  </label>
                                </div>
                              </div>

                            </label>
                          </nav>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- fin formulario -->
        </section>


      </form>
    </div>
  </div>
</div>
